// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"c90ab8e5","lsc":"d0b8284c","others":"2847e71f"}[chunkId] + ".chunk.js";
};